import PropTypes from 'prop-types'
import classNames from 'classnames'

import CloudinaryMedia from 'components/CloudinaryMedia'

import s from './PostItem.module.css'

function PostItem({
  image = '',
  title = '',
  brand = '',
  publication = '',
  lightUi = false,
  className = '',
}) {
  if (!image) return null
  const setTag = publication ? publication : brand
  return (
    <div
      className={classNames(s.container, className, {
        [s.light]: lightUi === true,
      })}
    >
      <div className={s.imgWrap}>
        <CloudinaryMedia
          className={s.img}
          images={[
            { url: image, params: 'w_240,f_auto' },
            { url: image, params: 'w_350,f_auto' },
          ]}
        />
      </div>
      {title && (
        <h2 className={s.title} dangerouslySetInnerHTML={{ __html: title }} />
      )}
      {setTag && (
        <span className={s.tag} dangerouslySetInnerHTML={{ __html: setTag }} />
      )}
    </div>
  )
}

PostItem.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string,
  brand: PropTypes.string,
  publication: PropTypes.string,
  lightUi: PropTypes.bool,
  className: PropTypes.string,
}

export default PostItem
